<script>
	import Stars from './stars.svelte'
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	export let song;
	export let showScore = false;

	function getDelayString(s) {
		const d = Math.round(s.dayDelay());
		const str = "hráno "
		switch (d) {
			case 0: return str + "dnes";
			case 1: return str + "včera";
			default: return str + `před ${d} dny`;
		}
	}
</script>

<style>
	li {
		padding: 0.3em;
	}
</style>

<li>
	<Stars stars={song.stars}/>
	<span class="songName clickable" on:click={e => dispatch('setActSong', song)}>{song.name}</span>
	{#if song.last}
		{getDelayString(song)}
		{#if showScore}({Math.round(song.getScore())}){/if}
	{/if}
	<span on:click={e => dispatch("deleteSong", song)} class="trash clickable">&#x1f5d1;</span>
</li>
